import Parent from "parentjs/controllers/toi_controller.js";
export default Parent;
